"use client";

import SkeletonLoader from "@/components/layout/skeleton-loader/skeleton-loader";
import React, { useState } from "react";

type Props = {
  src: string | undefined;
  alt: string;
};

const StandardTokenImageLoader = ({ src, alt }: Props) => {
  const [isLoaded, setIsLoaded] = useState(false);
  // TODO Placeholder for missing images
  return (
    <>
      {src && (
        // eslint-disable-next-line @next/next/no-img-element
        <img
          src={src}
          alt={alt}
          onLoad={() => setIsLoaded(true)}
          width={100}
          // height={200}
          style={{
            height: "auto",
          }}
        />
      )}
      {!isLoaded && <SkeletonLoader />}
    </>
  );
};

export default StandardTokenImageLoader;
